






































































































































































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { TipoTelefone, DppFinal, Acompanhamento } from '../../../../back/src/types';
import { awsS3URL, tipoTelefoneIcons } from '../../utils/constants';
import { calculoIdadeGestacional, calculaImc } from '../../utils/functions';
import Requester from '../../requester/index';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import ThePacientesAvisosResumo from './ThePacientesAvisosResumo.vue';
import ThePacienteWebcamDialog from './ThePacienteWebcamDialog.vue';
import PacienteBotaoCopiaDados from './PacienteBotaoCopiaDados.vue';

export default Vue.extend({
  name: 'ThePacientesResumo',
  components: {
    IfEmptyTextPrintNA,
    ThePacientesAvisosResumo,
    ThePacienteWebcamDialog,
    PacienteBotaoCopiaDados,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showEnderecoCompleto: false,
      file: null,
      pathNovaImagem: null,
      webcamPicture: null,
      webcamDialog: false,
      loadingCarteira: false,
      loadingProntuario: false,
      menuProntuarioCompleto: false,
      prontuarioCompletoOptions: {
        mostrarQueixasCondutas: false,
        preNatalOnly: true,
      },
    };
  },
  computed: {
    labelProntuarioCompletoOptionsMostrarQueixasCondutas() {
      return this.prontuarioCompletoOptions.mostrarQueixasCondutas
        ? 'Mostrar descrição consultas'
        : 'Omitir descrição consultas';
    },
    labelProntuarioCompletoOptionsPreNatalOnly() {
      return this.prontuarioCompletoOptions.preNatalOnly ? 'Pré-Natal' : 'Completo';
    },
    acompanhamentoColor() {
      switch (this.paciente.acompanhamento) {
        case Acompanhamento.COLETIVO:
          return 'warning darken-2';
        case Acompanhamento.CASA_DE_PARTO:
          return 'success darken-2';
        case Acompanhamento.PARTICULAR:
          return 'primary darken-2';
        default:
          return 'secondary lighten-2';
      }
    },
    acompanhamentoIcon() {
      switch (this.paciente.acompanhamento) {
        case Acompanhamento.COLETIVO:
          return 'far fa-circle';
        case Acompanhamento.CASA_DE_PARTO:
          return 'fa-clinic-medical';
        case Acompanhamento.PARTICULAR:
          return 'fa-user-md';
        default:
          return 'fa-notes-medical';
      }
    },
    acompanhamentoTexto() {
      switch (this.paciente.acompanhamento) {
        case Acompanhamento.COLETIVO:
          return 'Coletivo Nascer';
        case Acompanhamento.CASA_DE_PARTO:
          return 'Casa de Parto';
        case Acompanhamento.PARTICULAR:
          return `${
            this.paciente.responsavel
              ? this.paciente.responsavel.nome
              : 'Responsável não selecionada'
          }`;
        default:
          return 'Em triagem';
      }
    },
    enderecoCopy(): string {
      /* eslint-disable-next-line max-len */
      return `${this.paciente.logradouro}${', '}${this.paciente.numero}${' - '}${
        this.paciente.bairro
      }${', '}${this.paciente.cidade}${' - '}${this.paciente.estado}`;
    },
    enderecoCompleto(): string {
      /* eslint-disable-next-line max-len */
      if (this.paciente.cidade) {
        return `${this.paciente.logradouro}${', '}${this.paciente.numero}${
          this.paciente.complemento ? ` - ${this.paciente.complemento}` : ''
        }${' - '}${this.paciente.bairro}${', '}${this.paciente.cidade}${' - '}${
          this.paciente.estado
        }`;
      }
      return '';
    },
    vRowClass(): string {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'd-flex flex-column';
      }
      return '';
    },
    divPacienteClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return 'd-flex justify-start breakLineClass';
    },
    divAvatarClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column justify-center align-center mb-6';
      }
      return '';
    },
    idadeGestacionalAtual(): string {
      return calculoIdadeGestacional(this.paciente.gestacao_atual, null, true);
    },
    idadeGestacionalInicio(): string {
      if (this.paciente.gestacao_atual.datetime_triagem) {
        return calculoIdadeGestacional(
          this.paciente.gestacao_atual,
          this.paciente.gestacao_atual.datetime_triagem,
          true,
        );
      }
      return '';
    },
    titleIdadeGestacionalInicio() {
      return this.paciente.gestacao_atual.datetime_triagem
        ? `Data da triagem: ${moment(this.paciente.gestacao_atual.datetime_triagem)
          .tz('America/Sao_Paulo')
          .format('DD/MM/YYYY')}`
        : '';
    },
    dpp(): string {
      if (!this.paciente.gestacao_atual) {
        return '';
      }
      if (this.paciente.gestacao_atual.dpp_final === DppFinal.M) {
        if (!this.paciente.gestacao_atual.data_ultima_menstruacao) {
          return '';
        }
        const momentDate = moment(this.paciente.gestacao_atual.data_ultima_menstruacao).add(
          40,
          'w',
        );
        if (!momentDate.isValid()) {
          return 'DPP inválida';
        }
        return momentDate.utc().format('DD/MM/YYYY');
      }
      if (this.paciente.gestacao_atual.dpp_final === DppFinal.U) {
        if (!this.paciente.gestacao_atual.data_provavel_parto_us) {
          return '';
        }
        const momentDate = moment(this.paciente.gestacao_atual.data_provavel_parto_us);
        if (!momentDate.isValid()) {
          return 'DPP inválida';
        }
        return momentDate.utc().format('DD/MM/YYYY');
      }
      return '';
    },
    dppLabel(): string {
      if (!this.paciente.gestacao_atual) {
        return '';
      }
      if (this.paciente.gestacao_atual.dpp_final === DppFinal.M) {
        return '(DUM)';
      }
      if (this.paciente.gestacao_atual.dpp_final === DppFinal.U) {
        return '(US)';
      }
      return '';
    },
    pesoInicialKg(): string {
      if (this.paciente.gestacao_atual && this.paciente.gestacao_atual.peso_inicial_gramas) {
        const pesoInicialKg = this.paciente.gestacao_atual.peso_inicial_gramas / 1000;
        return `${new Intl.NumberFormat('pt-BR', {
          minimumFractionDigits: 1,
        }).format(pesoInicialKg)} kg`;
      }
      return '';
    },
    imcInicial() {
      if (this.paciente.gestacao_atual) {
        return calculaImc(
          this.paciente.gestacao_atual.peso_inicial_gramas,
          this.paciente.altura_cm,
        );
      }
      return null;
    },
    titleParidade() {
      return !this.paciente.paridade
        ? 'Cadastrar gestações anteriores ou indicar primeira gestação na atual.'
        : '';
    },
    srcImagem(): string {
      if (this.webcamPicture) {
        return this.webcamPicture;
      }
      if (this.file) {
        return URL.createObjectURL(this.file);
      }
      if (this.pathNovaImagem) {
        return this.pathNovaImagem;
      }
      if (this.paciente.foto_aws_key) {
        return `${awsS3URL}${this.paciente.foto_aws_key}`;
      }
      return '';
    },
  },
  methods: {
    linkWhatsapp(telefone: string) {
      if (this.$vuetify.breakpoint.xsOnly) {
        return `https://api.whatsapp.com/send?phone=55${telefone.replace(/\D/g, '')}`;
      }
      return `https://web.whatsapp.com/send?phone=55${telefone.replace(/\D/g, '')}`;
    },
    iconTelefone(tipoTelefone: TipoTelefone): string {
      if (_.has(tipoTelefoneIcons, tipoTelefone)) {
        return tipoTelefoneIcons[tipoTelefone];
      }
      return '';
    },
    clipboardCopySuccess() {
      this.$root.$emit('avisoSnackbar', {
        color: 'info',
        text: 'Endereço copiado para a área de transferência.',
      });
    },
    clipboardCopyError() {
      this.$root.$emit('avisoSnackbar', {
        color: 'success',
        text: 'Não foi possível copiar o endereço.',
      });
    },
    fileChange($event): void {
      this.webcamPicture = null;
      this.imgError = false;
      const files = $event.target.files || $event.dataTransfer.files;
      if (files.length > 0) {
        this.file = _.first(files);
      } else {
        this.file = null;
      }
    },
    fotoSelecionada(imagem) {
      this.file = null;
      this.webcamPicture = imagem;
      this.webcamDialog = false;
    },
    async uploadFile(): Promise<boolean> {
      if (this.file || this.webcamPicture) {
        const formData = new FormData();
        if (this.file) {
          formData.append('file', this.file);
        } else {
          formData.append('img_string', this.webcamPicture);
        }
        formData.append('paciente_id', this.paciente.id);
        try {
          const response = await Requester.paciente.uploadFoto(formData);
          this.pathNovaImagem = null;
          setTimeout(() => {
            this.pathNovaImagem = `${awsS3URL}${response.data.foto_aws_key}`;
          }, 400);
          this.$root.$emit('avisoSnackbar', {
            color: 'success',
            text: 'Foto alterada com sucesso!',
          });
          this.file = null;
        } catch (err) {
          this.$root.$emit('requestError', err);
          return false;
        }
      }
      return true;
    },
    async downloadCarteiraPreNatal() {
      this.loadingCarteira = true;
      try {
        const response = await Requester.paciente.carteiraPreNatal(
          this.paciente.id,
          this.paciente.gestacao_atual.id,
        );
        const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `Carteira de Pré-Natal - ${this.paciente.nome} - ${moment().format('DD_MM_YYYY')}.pdf`,
        );
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        this.$root.$emit('requestError', error);
      }
      this.loadingCarteira = false;
    },
    async downloadProntuarioCompleto(preNatalOnly: boolean) {
      this.loadingProntuario = true;
      try {
        const response = await Requester.paciente.prontuarioCompleto(
          this.paciente.id,
          this.prontuarioCompletoOptions,
        );
        const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `Prontuário ${this.prontuarioCompletoOptions.preNatalOnly ? 'Pré-Natal' : 'Completo'} - ${
            this.paciente.nome
          } - ${moment().format('DD_MM_YYYY')}.pdf`,
        );
        document.body.appendChild(link);
        link.click();
        this.menuProntuarioCompleto = false;
      } catch (error) {
        this.$root.$emit('requestError', error);
      }
      this.loadingProntuario = false;
    },
  },
});
